<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2">
    <div class="form-horizontal">
  
      <div class="form-group row">
        <div class="col-md-12">
          <yt-dropdown-picklist
            [ModelName]="'podvrstadokumentastavka'"
            [GetName]="'GetByUrl'"
            [ModelProperty]="'Sifra,Naziv'"
            [GetParameters] = "[{ Name: 'url', Value: '/kad/angazovanjeroanex' }]"
            [OrderBy]="'Naziv'"
            [AllowAddNew]="false"
            formControlName="PodvrstaDokumentaStavkaID"
            [Label]="'ANGAZOVANJERO.PODVRSTADOKUMENTASTAVKA.SINGULAR'"
            (OnItemSelected)="onPodvrstaDokumentaStavkaSelected($event)"
          >
          </yt-dropdown-picklist>
        </div>
      </div>
          
      <div class="form-group row">
        <div class="col-md-6">
          <yt-fw-date-picker-popup
                formControlName="Datum"
                name="txtDatum" 
                [Label]="'DOKUMENT.DATUM.SINGULAR'"
                [ngClass]="{'is-invalid': submitted && fc.Datum.invalid}"
                (OnDateSelected)="onDatumChange($event)">
          </yt-fw-date-picker-popup>
        </div>  
        <div class="col-md-6">
          <div class="input-group">
            <yt-input
              [Type]="'text'"
              [Label]="'ANGAZOVANJERO.BROJ.SINGULAR'"
              formControlName="Broj"            
              [ngClass]="{'is-invalid': submitted && fc.Broj.invalid}">
            </yt-input>
            <!-- <div class="input-group-append">
              <span class="span-control">/</span><span *ngIf="baseFormGroup.get('Datum').value != null" class="span-control">{{baseFormGroup.get('Datum').value.year}}</span>
            </div> -->
          </div>
        </div>
      </div>  

      <div class="form-group row">
        <div class="col-md-6">
          <yt-dropdown-picklist
              [ModelName]="'statusro'"
              [GetName]="'get'"
              [ModelProperty]="'Naziv'"
              [OrderBy]="'Naziv'"
              [AllowAddNew]='true'
              formControlName="StatusRoID"                                   
              [ngClass]="{'is-invalid': submitted && fc.StatusRoID.invalid}"
              [Label]="'ANGAZOVANJERO.STATUSRO.SINGULAR'">
          </yt-dropdown-picklist>
          <div class="form-error" *ngIf="submitted && fc.StatusRoID.invalid">
              <span *ngFor="let validation of errorMessages.StatusRoID">
              <span class="error-message" *ngIf="fc.StatusRoID.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
              </span>
          </div>
        </div> 
        <div class="col-md-3">
          <yt-fw-date-picker-popup
              name="txtOdDatuma"
              formControlName="OdDatuma"
              [ngClass]="{'is-invalid' : submitted && fc.OdDatuma.invalid}"
              [Label]="'ANGAZOVANJERO.ODDATUMA.SINGULAR'">
          </yt-fw-date-picker-popup>
          <div class="form-error" *ngIf="submitted && fc.OdDatuma.invalid">
              <span *ngFor="let validation of errorMessages.OdDatuma">
                  <span class="error-message" *ngIf="fc.OdDatuma.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
              </span>
          </div>
        </div>

        <div class="col-md-3">
            <yt-fw-date-picker-popup
                name="txtDoDatuma"
                formControlName="DoDatuma"
                [ngClass]="{'is-invalid' : submitted && fc.DoDatuma.invalid}"
                [Label]="'ANGAZOVANJERO.DODATUMA.SINGULAR'">
            </yt-fw-date-picker-popup>
            <div class="form-error" *ngIf="submitted && fc.DoDatuma.invalid">
                <span *ngFor="let validation of errorMessages.DoDatuma">
                    <span class="error-message" *ngIf="fc.DoDatuma.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                </span>
            </div>
        </div>
      </div>

      <div class="form-group row" *ngIf="!editMode">
        <div class="col-md-12"> 
          <yt-dropdown-picklist
            [ModelName]="'zaposleni'" 
            [GetName]="'get'" 
            [ModelProperty]="'Prezime,Ime,Jmbg'"
            [OrderBy]="'Prezime'"
            formControlName="OsobaID" 
            [AllowAddNew]="false"          
            [Label]="'ANGAZOVANJERO.OSOBA.SINGULAR'"
          >
          </yt-dropdown-picklist>
        </div>
      </div>
  
      <!-- Ovde treba da idu nezaposleni umesto osoba -->
      <div class="form-group row" *ngIf="editMode">
        <div class="col-md-12">
          <yt-dropdown-picklist
            [ModelName]="'osoba'"
            [GetName]="'get'"
            [ModelProperty]="'Prezime,Ime,Jmbg'"
            [OrderBy]="'Prezime'"
            [AllowAddNew]="true"
            formControlName="OsobaID"
            [Label]="'ANGAZOVANJERO.OSOBA.SINGULAR'"
          >
          </yt-dropdown-picklist>
        </div>
      </div>
      
      <!-- <div class="form-group row" *ngIf="!Ugovor">
        <div class="col-md-12">
          <yt-dropdown-picklist
            [ModelName]="'angazovanjero'"
            [GetName]="'get'"
            [ModelProperty]="'Broj'"
            [OrderBy]="'Broj'"
            [AllowAddNew]="false"
            formControlName="TataID"
            [Label]="'ANGAZOVANJERO.TATAID.SINGULAR'"
          >
          </yt-dropdown-picklist>
        </div>
      </div> -->
      <!-- <div class="form-group row" *ngIf="RaskidUgovora">
        <div class="col-md-12">
          <yt-dropdown-picklist
              [ModelName]="'razlogprestankaro'"
              [GetName]="'get'"
              [ModelProperty]="'Naziv'"
              [OrderBy]="'Naziv'"
              [AllowAddNew]='true'
              formControlName="RazlogPrestankaRoID"            
              [Label]="'ANGAZOVANJERO.RAZLOGPRESTANKARO.SINGULAR'">
            </yt-dropdown-picklist>
          <div class="form-error" *ngIf="submitted && fc.RazlogPrestankaRoID.invalid">
              <span *ngFor="let validation of errorMessages.RazlogPrestankaRoID">
              <span class="error-message" *ngIf="fc.RazlogPrestankaRoID.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
              </span>
          </div>
        </div>
      </div> -->
      
      <div class="form-group row">
        <div class="col-md-6">
          <yt-dropdown-picklist
            [ModelName]="'radnomesto'" 
            [GetName]="'getRoot'" 
            [ModelProperty]="'Naziv'"
            [OrderBy]="'Naziv'"
            formControlName="RadnoMestoID" 
            [AllowAddNew]="true"
            [Type]="'treeview'"
            [Label]="'ANGAZOVANJERO.RADNOMESTO.SINGULAR'"
            [ngClass]="{'is-invalid': submitted && fc.RadnoMestoID.invalid}"
          >
          </yt-dropdown-picklist>
        </div>
        <div class="col-md-6">
          <yt-autocomplete
            [ModelName]="'mesto'"
            [GetName]="'getByNaziv'"
            [ModelProperty]="'Naziv'"
            [OrderBy]="'Naziv'"
            [Label]="'ANGAZOVANJERO.MESTORADA.SINGULAR'"
            formControlName="MestoRadaID"
          >
          </yt-autocomplete>
          <div class="form-error" *ngIf="submitted && fc.MestoRadaID.invalid">
              <span *ngFor="let validation of errorMessages.MestoRadaID">
              <span class="error-message" *ngIf="fc.MestoRadaID.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
              </span>
          </div>
        </div>
      </div>
  
  
      <div class="form-group row">
        <div class="col-md-6">
          <yt-dropdown-picklist
              [ModelName]="'radnovreme'"
              [GetName]="'get'"
              [ModelProperty]="'Naziv'"
              [OrderBy]="'Naziv'"
              [AllowAddNew]='false'
              formControlName="RadnoVremeID"       
              [ngClass]="{'is-invalid': (submitted && fc.RadnoVremeID.invalid) || baseFormGroup.errors?.RadnoVremePrcAng}"
              [Label]="'ANGAZOVANJERO.RADNOVREME.SINGULAR'"
              (GetItems)="RadnoVremeGetItems($event)"
          >
          </yt-dropdown-picklist>
          <div class="form-error" *ngIf="submitted && fc.RadnoVremeID.invalid">
              <span *ngFor="let validation of errorMessages.RadnoVremeID">
              <span class="error-message" *ngIf="fc.RadnoVremeID.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
              </span>
          </div>
          <div class="form-error" *ngIf="baseFormGroup.errors?.RadnoVremePrcAng?.valid==false">
            <span class="error-message">
                <span translate={{baseFormGroup.errors.RadnoVremePrcAng.message}}></span>
            </span>
          </div>
        </div>
  
        <div class="col-md-3">
          <div class="input-group">
            <yt-number-input-v3
              name="txtPrcAng"
              formControlName="PrcAng"
              [Label]="'ANGAZOVANJERO.PRCANG.SINGULAR'"
              [ngClass]="{'is-invalid': (submitted && fc.PrcAng.invalid) || baseFormGroup.errors?.RadnoVremePrcAng}"
            >
            </yt-number-input-v3>     
          </div>
        </div>
        <div class="col-md-3">
          <div class="input-group">
            <yt-number-input-v3            
              [Label]="'ANGAZOVANJERO.NEDFONDSATI.SINGULAR'"
              formControlName="NedFondSati"
              [FormatString]="'1.0-0'">
            </yt-number-input-v3>     
          </div>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-4">
          <yt-number-input-v3
            name="txtKoefZarade"
            formControlName="KoefZarade"
            [Label]="'ANGAZOVANJERO.KOEFZARADE.SINGULAR'">
          </yt-number-input-v3>
        </div>
        <div class="col-md-4">
          <yt-dropdown-picklist
            [ModelName]="'beneficirani'"
            [GetName]="'get'"
            [ModelProperty]="'Naziv'"
            [OrderBy]="'Naziv'"
            [AllowAddNew]='false'
            formControlName="BeneficiraniID"          
            [ngClass]="{'is-invalid': submitted && fc.BeneficiraniID.invalid}"
            [Label]="'ANGAZOVANJERO.BENEFICIRANI.SINGULAR'">
          </yt-dropdown-picklist>
          <div class="form-error" *ngIf="submitted && fc.BeneficiraniID.invalid">
              <span *ngFor="let validation of errorMessages.BeneficiraniID">
              <span class="error-message" *ngIf="fc.BeneficiraniID.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
              </span>
          </div>
        </div>
        <div class="col-md-4">
          <yt-number-input-v3
            name="txtBrojPoslodavaca"          
            [Label]="'ANGAZOVANJERO.BROJPOSLODAVACA.SINGULAR'"
            formControlName="BrojPoslodavaca"
            [FormatString]="'1.0-0'">
          </yt-number-input-v3>
        </div>
      </div>
  
      <div class="form-group row">
        <div class="col-md-12">
          <yt-dropdown-picklist
            [ModelName]="'valuta'"
            [GetName]="'get'"
            [ModelProperty]="'Naziv'"
            [OrderBy]="'Naziv'"
            [AllowAddNew]='false'
            formControlName="ValutaID"
            [ngClass]="{'is-invalid': submitted && fc.ValutaID.invalid}"
            [Label]="'ANGAZOVANJERO.VALUTA.SINGULAR'">
          </yt-dropdown-picklist>
          <div class="form-error" *ngIf="submitted && fc.ValutaID.invalid">
              <span *ngFor="let validation of errorMessages.ValutaID">
              <span class="error-message" *ngIf="fc.ValutaID.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
              </span>
          </div>
        </div>
      </div>  
  
      <div class="form-group row">
        <div class="col-md-6">
          <yt-number-input-v3
            name="txtNetoZarada"
            formControlName="NetoZarada"
            [Label]="'ANGAZOVANJERO.NETOZARADA.SINGULAR'">
          </yt-number-input-v3>
        </div>
        <div class="col-md-6">
          <yt-number-input-v3
            name="txtBrutoZarada"
            formControlName="BrutoZarada"
            [Label]="'ANGAZOVANJERO.BRUTOZARADA.SINGULAR'">
          </yt-number-input-v3>
        </div>
  
      </div>  
  
      <div class="form-group row">
        <div class="col-md-6">
          <yt-number-input-v3
            name="txtNetoCenaSata"
            formControlName="NetoCenaSata"
            [Label]="'ANGAZOVANJERO.NETOCENASATA.SINGULAR'">
          </yt-number-input-v3>
        </div>
        <div class="col-md-6">
          <yt-number-input-v3
            name="txtBrutoCenaSata"
            formControlName="BrutoCenaSata"
            [Label]="'ANGAZOVANJERO.BRUTOCENASATA.SINGULAR'">
          </yt-number-input-v3>
        </div>
      </div>  
    </div>
  </form>